/** Mirrors subject.maxLength in the reply send and render API schemas. */
export const REPLY_SUBJECT_MAX_LENGTH = 255;
